import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';

import { CashCountGridComponent, CashCountResult, CashCounts } from '../cash-count-grid/cash-count-grid.component';

export interface CashCountData {
	title: string;
	subtitle?: string;
	// Repère affiché sous le total (ex. « attendu : 50,00 € ») ; jamais comparé.
	hint?: string;
	counts?: CashCounts;
}

export function openCashCount(dialog: MatDialog, data: CashCountData): Observable<CashCountResult | undefined> {
	// autoFocus coupé : le premier tabulable est la croix, une Entrée y refermerait la boîte ; le focus va à la ligne 1 c.
	return dialog.open<CashCountDialogComponent, CashCountData, CashCountResult>(CashCountDialogComponent, { data, maxWidth: '96vw', autoFocus: false, restoreFocus: true }).afterClosed();
}

@Component({
	selector: 'app-cash-count-dialog',
	standalone: true,
	templateUrl: './cash-count-dialog.component.html',
	styleUrls: ['./cash-count-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDialogModule, MatButtonModule, MatIconModule, CashCountGridComponent],
})
export class CashCountDialogComponent implements AfterViewInit {

	public dialogRef = inject(MatDialogRef<CashCountDialogComponent, CashCountResult>);
	public data: CashCountData = inject(MAT_DIALOG_DATA);
	@ViewChild(CashCountGridComponent, { static: true }) grid!: CashCountGridComponent;

	ngAfterViewInit(): void {
		this.grid.focusFirst();
	}

	clear(): void {
		this.grid.clear();
		this.grid.focusFirst();
	}

	apply(): void {
		const r = this.grid.result();
		if (r) this.dialogRef.close(r);
	}

	cancel(): void {
		this.dialogRef.close();
	}
}
